"use strict";

/*
  SortTable
  version 2 - ES6 Compatible
  7th April 2007
  Stuart Langridge, http://www.kryogenix.org/code/browser/sorttable/

  Instructions:
  Download this file
  Add <script src="sorttable.js"></script> to your HTML
  Add class="sortable" to any table you'd like to make sortable
  Click on the headers to sort

  Thanks to many, many people for contributions and suggestions.
  Licenced as X11: http://www.kryogenix.org/code/browser/licence.html
  This basically means: do what you want with it.
*/

const stIsIE = false; // IE detection no longer needed for modern browsers

const sorttable = {
  initialized: false,

  init() {
    // quit if this function has already been called
    if (this.initialized) return;
    // flag this function so we don't do the same thing twice
    this.initialized = true;
    // kill the timer
    if (window._sorttableTimer) {
      clearInterval(window._sorttableTimer);
    }

    if (!document.createElement || !document.getElementsByTagName) return;

    this.DATE_RE = /^(\d\d?)[\/\.-](\d\d?)[\/\.-]((\d\d)?\d\d)$/;

    const tables = document.getElementsByTagName("table");
    for (const table of tables) {
      try {
        if (table.className.search(/\bsortable\b/) !== -1) {
          this.makeSortable(table);
        }
      } catch (error) {
        console.error("Error making table sortable", error);
      }
    }
  },

  makeSortable(table) {
    if (table.getElementsByTagName("thead").length === 0) {
      // table doesn't have a tHead. Since it should have, create one and
      // put the first table row in it.
      const thead = document.createElement("thead");
      thead.appendChild(table.rows[0]);
      table.insertBefore(thead, table.firstChild);
    }
    // Safari doesn't support table.tHead, sigh
    if (table.tHead === null) {
      table.tHead = table.getElementsByTagName("thead")[0];
    }

    if (table.tHead.rows.length !== 1) return; // can't cope with two header rows

    // Sorttable v1 put rows with a class of "sortbottom" at the bottom (as
    // "total" rows, for example). This is B&R, since what you're supposed
    // to do is put them in a tfoot. So, if there are sortbottom rows,
    // for backwards compatibility, move them to tfoot (creating it if needed).
    const sortbottomrows = [];
    for (let i = 0; i < table.rows.length; i++) {
      if (table.rows[i].className.search(/\bsortbottom\b/) !== -1) {
        sortbottomrows.push(table.rows[i]);
      }
    }
    if (sortbottomrows.length > 0) {
      let tfoot = table.tFoot;
      if (tfoot === null) {
        // table doesn't have a tfoot. Create one.
        tfoot = document.createElement("tfoot");
        table.appendChild(tfoot);
      }
      for (const row of sortbottomrows) {
        tfoot.appendChild(row);
      }
    }

    // work through each column and calculate its type
    const headrow = table.tHead.rows[0].cells;
    for (let i = 0; i < headrow.length; i++) {
      // manually override the type with a sorttable_type attribute
      if (!headrow[i].className.match(/\bsorttable_nosort\b/)) {
        // skip this col
        const mtch = headrow[i].className.match(/\bsorttable_([a-z0-9]+)\b/);
        let override;
        if (mtch) {
          override = mtch[1];
        }
        if (mtch && typeof sorttable["sort_" + override] === "function") {
          headrow[i].sorttable_sortfunction = sorttable["sort_" + override];
        } else {
          headrow[i].sorttable_sortfunction = sorttable.guessType(table, i);
        }
        // make it clickable to sort
        headrow[i].sorttable_columnindex = i;
        headrow[i].sorttable_tbody = table.tBodies[0];
        this.addEvent(
          headrow[i],
          "click",
          function (e) {
            if (this.className.search(/\bsorttable_sorted\b/) !== -1) {
              // if we're already sorted by this column, just
              // reverse the table, which is quicker
              sorttable.reverse(this.sorttable_tbody);
              this.className = this.className.replace(
                "sorttable_sorted",
                "sorttable_sorted_reverse"
              );
              const sortfwdind = document.getElementById("sorttable_sortfwdind");
              if (sortfwdind) {
                this.removeChild(sortfwdind);
              }
              const sortrevind = document.createElement("span");
              sortrevind.id = "sorttable_sortrevind";
              sortrevind.innerHTML = "&nbsp;&#x25BE;";
              this.appendChild(sortrevind);
              return;
            }
            if (this.className.search(/\bsorttable_sorted_reverse\b/) !== -1) {
              // if we're already sorted by this column in reverse, just
              // re-reverse the table, which is quicker
              sorttable.reverse(this.sorttable_tbody);
              this.className = this.className.replace(
                "sorttable_sorted_reverse",
                "sorttable_sorted"
              );
              const sortrevind = document.getElementById("sorttable_sortrevind");
              if (sortrevind) {
                this.removeChild(sortrevind);
              }
              const sortfwdind = document.createElement("span");
              sortfwdind.id = "sorttable_sortfwdind";
              sortfwdind.innerHTML = "&nbsp;&#x25B4;";
              this.appendChild(sortfwdind);
              return;
            }

            // remove sorttable_sorted classes
            const theadrow = this.parentNode;
            for (const cell of theadrow.childNodes) {
              if (cell.nodeType === 1) {
                // an element
                cell.className = cell.className.replace(
                  "sorttable_sorted_reverse",
                  ""
                );
                cell.className = cell.className.replace("sorttable_sorted", "");
              }
            }
            let sortfwdind = document.getElementById("sorttable_sortfwdind");
            if (sortfwdind) {
              sortfwdind.parentNode.removeChild(sortfwdind);
            }
            const sortrevind = document.getElementById("sorttable_sortrevind");
            if (sortrevind) {
              sortrevind.parentNode.removeChild(sortrevind);
            }

            this.className += " sorttable_sorted";
            sortfwdind = document.createElement("span");
            sortfwdind.id = "sorttable_sortfwdind";
            sortfwdind.innerHTML = "&nbsp;&#x25B4;";
            this.appendChild(sortfwdind);

            // build an array to sort. This is a Schwartzian transform thing,
            // i.e., we "decorate" each row with the actual sort key,
            // sort based on the sort keys, and then put the rows back in order
            // which is a lot faster because you only do getInnerText once per row
            const row_array = [];
            const col = this.sorttable_columnindex;
            const rows = this.sorttable_tbody.rows;
            for (let j = 0; j < rows.length; j++) {
              row_array.push([
                sorttable.getInnerText(rows[j].cells[col]),
                rows[j],
              ]);
            }
            /* If you want a stable sort, uncomment the following line */
            //sorttable.shaker_sort(row_array, this.sorttable_sortfunction);
            /* and comment out this one */
            row_array.sort(this.sorttable_sortfunction);

            const tb = this.sorttable_tbody;
            for (const [, row] of row_array) {
              tb.appendChild(row);
            }
          }
        );
      }
    }
  },

  guessType(table, column) {
    // guess the type of a column based on its first non-blank row
    let sortfn = this.sort_alpha;
    for (let i = 0; i < table.tBodies[0].rows.length; i++) {
      const text = this.getInnerText(table.tBodies[0].rows[i].cells[column]);
      if (text !== "") {
        if (text.match(/^-?[£$¤]?[\d,.]+%?$/)) {
          return this.sort_numeric;
        }
        // check for a date: dd/mm/yyyy or dd/mm/yy
        // can have / or . or - as separator
        // can be mm/dd as well
        const possdate = text.match(this.DATE_RE);
        if (possdate) {
          // looks like a date
          const first = parseInt(possdate[1], 10);
          const second = parseInt(possdate[2], 10);
          if (first > 12) {
            // definitely dd/mm
            return this.sort_ddmm;
          } else if (second > 12) {
            return this.sort_mmdd;
          } else {
            // looks like a date, but we can't tell which, so assume
            // that it's dd/mm (English imperialism!) and keep looking
            sortfn = this.sort_ddmm;
          }
        }
      }
    }
    return sortfn;
  },

  getInnerText(node) {
    // gets the text we want to use for sorting for a cell.
    // strips leading and trailing whitespace.
    // this is *not* a generic getInnerText function; it's special to sorttable.
    // for example, you can override the cell text with a customkey attribute.
    // it also gets .value for <input> fields.

    if (!node) return "";

    const hasInputs =
      typeof node.getElementsByTagName === "function" &&
      node.getElementsByTagName("input").length;

    if (node.getAttribute("sorttable_customkey") !== null) {
      return node.getAttribute("sorttable_customkey");
    } else if (typeof node.textContent !== "undefined" && !hasInputs) {
      return node.textContent.replace(/^\s+|\s+$/g, "");
    } else if (typeof node.innerText !== "undefined" && !hasInputs) {
      return node.innerText.replace(/^\s+|\s+$/g, "");
    } else if (typeof node.text !== "undefined" && !hasInputs) {
      return node.text.replace(/^\s+|\s+$/g, "");
    } else {
      switch (node.nodeType) {
        case 3:
          if (node.nodeName.toLowerCase() === "input") {
            return node.value.replace(/^\s+|\s+$/g, "");
          }
        // falls through
        case 4:
          return node.nodeValue.replace(/^\s+|\s+$/g, "");
        case 1:
        case 11:
          let innerText = "";
          for (let i = 0; i < node.childNodes.length; i++) {
            innerText += this.getInnerText(node.childNodes[i]);
          }
          return innerText.replace(/^\s+|\s+$/g, "");
        default:
          return "";
      }
    }
  },

  reverse(tbody) {
    // reverse the rows in a tbody
    const newrows = [];
    for (let i = 0; i < tbody.rows.length; i++) {
      newrows.push(tbody.rows[i]);
    }
    for (let i = newrows.length - 1; i >= 0; i--) {
      tbody.appendChild(newrows[i]);
    }
  },

  /* sort functions
     each sort function takes two parameters, a and b
     you are comparing a[0] and b[0] */
  sort_numeric(a, b) {
    let aa = parseFloat(a[0].replace(/[^0-9.-]/g, ""));
    if (isNaN(aa)) aa = 0;
    let bb = parseFloat(b[0].replace(/[^0-9.-]/g, ""));
    if (isNaN(bb)) bb = 0;
    return aa - bb;
  },
  sort_alpha(a, b) {
    if (a[0] === b[0]) return 0;
    if (a[0] < b[0]) return -1;
    return 1;
  },
  sort_ddmm(a, b) {
    let mtch = a[0].match(sorttable.DATE_RE);
    let y = mtch[3];
    let m = mtch[2];
    let d = mtch[1];
    if (m.length === 1) m = "0" + m;
    if (d.length === 1) d = "0" + d;
    const dt1 = y + m + d;
    mtch = b[0].match(sorttable.DATE_RE);
    y = mtch[3];
    m = mtch[2];
    d = mtch[1];
    if (m.length === 1) m = "0" + m;
    if (d.length === 1) d = "0" + d;
    const dt2 = y + m + d;
    if (dt1 === dt2) return 0;
    if (dt1 < dt2) return -1;
    return 1;
  },
  sort_mmdd(a, b) {
    let mtch = a[0].match(sorttable.DATE_RE);
    let y = mtch[3];
    let d = mtch[2];
    let m = mtch[1];
    if (m.length === 1) m = "0" + m;
    if (d.length === 1) d = "0" + d;
    const dt1 = y + m + d;
    mtch = b[0].match(sorttable.DATE_RE);
    y = mtch[3];
    d = mtch[2];
    m = mtch[1];
    if (m.length === 1) m = "0" + m;
    if (d.length === 1) d = "0" + d;
    const dt2 = y + m + d;
    if (dt1 === dt2) return 0;
    if (dt1 < dt2) return -1;
    return 1;
  },

  shaker_sort(list, comp_func) {
    // A stable sort function to allow multi-level sorting of data
    // see: http://en.wikipedia.org/wiki/Cocktail_sort
    // thanks to Joseph Nahmias
    let b = 0;
    let t = list.length - 1;
    let swap = true;

    while (swap) {
      swap = false;
      for (let i = b; i < t; ++i) {
        if (comp_func(list[i], list[i + 1]) > 0) {
          const q = list[i];
          list[i] = list[i + 1];
          list[i + 1] = q;
          swap = true;
        }
      }
      t--;

      if (!swap) break;

      for (let i = t; i > b; --i) {
        if (comp_func(list[i], list[i - 1]) < 0) {
          const q = list[i];
          list[i] = list[i - 1];
          list[i - 1] = q;
          swap = true;
        }
      }
      b++;
    }
  },

  // Modern event handling
  addEvent(element, type, handler) {
    element.addEventListener(type, handler, false);
  }
};
/* ******************************************************************
   Modern initialization
   ****************************************************************** */

// Modern DOM ready handling
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => sorttable.init());
} else {
  // DOM is already loaded
  sorttable.init();
}

// Fallback for window load
window.addEventListener("load", () => sorttable.init());

// Export for module systems
if (typeof module !== "undefined" && module.exports) {
  module.exports = sorttable;
}
